
export type ManageDeviceProfilesState = {
    loading: boolean;
    success: boolean;
    error: string;
    selectedDeviceProfile?: string;

};

export const initialManageDeviceProfiles: ManageDeviceProfilesState = {
    loading: false,
    success: false,
    error: '',
    selectedDeviceProfile:''
};
